module.exports = __webpack_public_path__ + "static/media/How-it-works.1658fe01.svg";